import { render, staticRenderFns } from "./DesignPage.vue?vue&type=template&id=2751c574&"
import script from "./DesignPage.vue?vue&type=script&lang=js&"
export * from "./DesignPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports